/**
 * StartNode.tsx
 * Startノードのビューコンポーネント
 * フローの開始点を視覚的に表現する緑色の円形ノード
 */
import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';

/**
 * Startノードの表示コンポーネント
 * - 右側にのみ接続ハンドル（source）を持つ
 * - memoで不要な再レンダリングを防止
 */
export const StartNodeView = memo(function StartNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="flow-node flow-node--terminal rounded-full border-2 border-green-500 bg-green-50 shadow-sm">
      <div className="flow-node__title text-center font-semibold text-green-700">
        {getNodeDisplayLabel('start', displayLanguage)}
      </div>
      {/* 出力ハンドル：ここから他のノードへ接続する */}
      <Handle type="source" position={Position.Right} className="!bg-green-500" />
    </div>
  );
});

